import lottie from 'lottie-web'
import KonamiCode from 'konami-code-js'

import gsap from 'gsap'
import Breakpoints from './Breakpoints'

import '../../scss/partials/_motionTime.scss'

import achievementUnlockedAnimation from '../../anims/achievementunlocked.json'
const ls = require('local-storage')

export default class MotionTime {
    constructor() {
        this.mtWindow = document.querySelector('.motionTime')
        this.openMtTimeline = null
        this.closeBtn = this.mtWindow.querySelector('.motionTime__closeBtn')

        this.items = document.querySelectorAll('.motionTime__items-list li')
        this.responsiveVideOverlay = document.querySelector(
            '.motionTime__responsive__video'
        )
        this.itemsVisualCloseBtn = document.querySelector(
            '.motionTime__responsive__video .video__closeBtn'
        )
        this.itemsVisual = this.mtWindow.querySelector(
            '.motionTime__item-content-visual .visual__video'
        )

        this.triggerBtn = document.querySelector('.sidebar__menu-special')
        this.headerNbUnlocked = document.querySelector(
            '.sidebar__menu .special__found-inner'
        )
        this.headerCount = document.querySelector(
            '.sidebar__menu .special__container'
        )

        this.triggerBtnHome = document.querySelector('.home__special')
        this.headerNbUnlockedHome = document.querySelector(
            '.home__special .special__found-inner'
        )
        this.headerCountHome = document.querySelector(
            '.home__special .special__container'
        )
    }

    init() {
        this.initStorage()
        this.initTriggerEvents()
        this.initAnimations()

        const konamiEvent = new KonamiCode(() => {
            this.unlockItem(4)
            document.body.classList.add('reverse--colorimetry')

            setTimeout(() => {
                document.body.classList.remove('reverse--colorimetry')
            }, 3000)
        })
    }

    initTriggerEvents() {
        // Opening on click
        this.triggerBtn.addEventListener('click', () => {
            this.openMtTimeline.play(0)
            setTimeout(() => {
                document.querySelector('.cursor').classList.add('color--white')
            }, 250)
        })

        this.triggerBtnHome.addEventListener('click', () => {
            this.openMtTimeline.play(0)
            setTimeout(() => {
                document.querySelector('.cursor').classList.add('color--white')
            }, 250)
        })

        // Closing on click on closeBtn
        this.closeBtn.addEventListener('click', () => {
            this.mtWindow.classList.remove('active')
            let mtActiveItem = this.mtWindow.querySelector(
                '.motionTime__items-list li.active'
            )

            if (mtActiveItem) {
                mtActiveItem.classList.remove('active')
            }

            let mtActiveVideoMobile = document.querySelector(
                '.motionTime__responsive__video .video__video.loaded'
            )
            let mtActiveVideo = document.querySelector(
                '.motionTime__item-content-visual .visual__video.loaded'
            )

            if (mtActiveVideoMobile) {
                mtActiveVideoMobile.classList.remove('loaded')
            }

            if (mtActiveVideo) {
                mtActiveVideo.classList.remove('loaded')
            }

            this.openMtTimeline.reverse()

            setTimeout(() => {
                document
                    .querySelector('.cursor')
                    .classList.remove('color--white')
            }, 1000)

            // If visual is opened
            this.mtWindow.classList.remove('no-scroll')
            this.itemsVisual.parentNode.classList.remove('loaded')
            this.itemsVisual.classList.remove('loading')
            this.itemsVisual.classList.remove('active')
        })

        // Closing on ESC keypress
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.closeBtn.click()
            }
        })

        // CLick on replayVideo in overlay

        this.items.forEach((item, index) => {
            const playBtn = item.querySelector('.replay__btn')

            playBtn.addEventListener('click', () => {
                const storage = this.getStorage()
                const status = storage.achievements[index]

                if (status == 'unlocked') {
                    // Responsive part
                    // First we stop the current item
                    this.responsiveVideOverlay.classList.add('active')
                    this.mtWindow.classList.add('no-scroll')

                    const currentActiveItemResponsive = document.querySelector(
                        '.motionTime__responsive__video .video__video.loaded'
                    )

                    if (currentActiveItemResponsive) {
                        const currentActiveItemResponsiveVideoElement = document.querySelector(
                            '.motionTime__responsive__video .video__video.loaded video'
                        )
                        currentActiveItemResponsiveVideoElement.pause()
                        currentActiveItemResponsive.classList.remove('loaded')
                        setTimeout(() => {
                            currentActiveItemResponsiveVideoElement.currentTime = 0
                        }, 200)
                    }

                    // Then we start the new one.
                    const videoToPlayResponsive = document.querySelector(
                        '.motionTime__responsive__video .video__video[data-index="' +
                            index +
                            '"]'
                    )
                    const videoElementResponsive = videoToPlayResponsive.querySelector(
                        'video'
                    )
                    videoToPlayResponsive.classList.add('loaded')
                    videoElementResponsive.play()

                    // Desktop part
                    // First we stop the current item
                    const currentActiveItem = document.querySelector(
                        '.motionTime__item-content-visual .visual__video.loaded'
                    )

                    if (currentActiveItem) {
                        const currentActiveItemVideoElement = document.querySelector(
                            '.motionTime__item-content-visual .visual__video.loaded video'
                        )
                        currentActiveItemVideoElement.pause()
                        currentActiveItem.classList.remove('loaded')
                        setTimeout(() => {
                            currentActiveItemVideoElement.currentTime = 0
                        }, 200)
                    }

                    const videoToPlay = document.querySelector(
                        '.motionTime__item-content-visual .visual__video[data-index="' +
                            index +
                            '"]'
                    )
                    const videoElement = videoToPlay.querySelector('video')
                    videoToPlay.classList.add('loaded')
                    videoElement.play()
                } else {
                    this.mtWindow.classList.remove('no-scroll')
                    this.itemsVisual.parentNode.classList.remove('loaded')

                    setTimeout(() => {
                        this.itemsVisual.innerHTML = ''
                    }, 400)
                }
            })
        })

        this.itemsVisualCloseBtn.addEventListener('click', () => {
            this.itemsVisual.parentNode.classList.remove('loaded')
            this.mtWindow.classList.remove('no-scroll')
            this.responsiveVideOverlay.classList.remove('active')
        })
    }

    initAnimations() {
        // Opening / Closing animation
        const overlay = this.mtWindow
        const overlayCloseBtn = this.closeBtn
        const overlayTitle = overlay.querySelector('.motionTime__title')
        const overlayIntroduction = overlay.querySelector(
            '.motionTime__introduction'
        )
        const overlayItems = overlay.querySelectorAll(
            '.motionTime__items-list li'
        )

        this.openMtTimeline = new gsap.timeline({
            paused: true,
            onComplete: () => {
                this.mtWindow.classList.add('active')
            },
        })

        this.openMtTimeline.add(
            gsap.fromTo(
                overlay,
                {
                    x: '100%',
                },
                {
                    duration: 0.4,
                    ease: 'expo.easeOut',
                    x: 0,
                }
            ),
            0
        )

        this.openMtTimeline.add(
            gsap.fromTo(
                overlayCloseBtn,
                {
                    opacity: 0,
                },
                {
                    duration: 0.2,
                    ease: 'expo.easeOut',
                    opacity: 1,
                }
            ),
            0.4
        )

        this.openMtTimeline.add(
            gsap.fromTo(
                overlayTitle,
                {
                    opacity: 0,
                    y: 40,
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.4,
                    ease: 'expo.easeOut',
                }
            ),
            0.4
        )

        this.openMtTimeline.add(
            gsap.fromTo(
                overlayIntroduction,
                {
                    y: 40,
                    opacity: 0,
                },
                {
                    duration: 0.4,
                    opacity: 1,
                    y: 0,
                    ease: 'expo.easeOut',
                }
            ),
            0.5
        )

        this.openMtTimeline.add(
            gsap.from(overlayItems, {
                duration: 0.2,
                x: -20,
                opacity: 0,
                ease: 'expo.easeOut',
                stagger: 0.05,
                clearProps: 'opacity',
            }),
            0.5
        )
    }

    initStorage() {
        const currentStorage = ls.get('motionTime')

        // Setting the basic thing up
        if (currentStorage == null) {
            const storageObj = {
                achievements: [
                    'locked',
                    'locked',
                    'locked',
                    'locked',
                    'locked',
                    'locked',
                    'locked',
                    'locked',
                    'locked',
                    'locked',
                ],
                caseStudiesVisited: [],
            }
            ls.set('motionTime', storageObj)
        } else {
            // System already initialized, all is fine.
            // Set correct number of unlocks on header
            const nbUnlocked = this.achievements_getNbUnlocked()
            this.front_headerUnlock(nbUnlocked)

            // Set correct class on motionTime overlay
            const listUnlocked = this.achievements_getListOfUnlocked()
            this.front_overlayUnlock(listUnlocked)

            // Preload all videos that need to be loaded
            listUnlocked.forEach((item) => {
                // item contains the index of the unlocked ones, that's why we pass it here.
                this.loadVideo(item)
            })
        }
    }

    getStorage() {
        const currentStorage = ls.get('motionTime')

        if (currentStorage !== null) {
            return currentStorage
        } else {
            throw new Error('MotionTime storage is not set.')
        }
    }

    setStorage(index, status = 'unlocked') {
        const storageObj = this.getStorage()
        storageObj.achievements[index] = status
        ls.set('motionTime', storageObj)
    }

    addCaseStudy(pathname) {
        const storageObj = this.getStorage()

        if (!storageObj.caseStudiesVisited.includes(pathname)) {
            storageObj.caseStudiesVisited.push(pathname)
        }

        ls.set('motionTime', storageObj)

        return storageObj.caseStudiesVisited.length
    }

    checkTrueNbCaseStudies() {
        const storageObj = this.getStorage()
        return new Set(storageObj.caseStudiesVisited).size
    }

    front_overlayUnlock(itemIndex) {
        if (typeof itemIndex === 'object') {
            itemIndex.forEach((index) => {
                this.items[index].classList.remove('item--locked')
                this.items[index].classList.add('item--unlocked')
            })
        } else {
            this.items[itemIndex].classList.remove('item--locked')
            this.items[itemIndex].classList.add('item--unlocked')
        }
    }

    front_headerUnlock(number = false) {
        // happening before storage increment.
        const nbUnlocked = this.achievements_getNbUnlocked()

        const nbUnlockedContainer = this.headerNbUnlocked

        if (nbUnlocked <= this.items.length) {
            let newNbUnlocked = 0
            if (!number) {
                newNbUnlocked = parseInt(nbUnlocked + 1)
            } else {
                newNbUnlocked = number
            }

            gsap.to(this.headerNbUnlockedHome, {
                duration: 0.1,
                ease: 'expo.easeOut',
                y: 40,
                onComplete: () => {
                    this.headerNbUnlockedHome.innerHTML = newNbUnlocked

                    gsap.set(this.headerNbUnlockedHome, {
                        y: -40,
                    })

                    gsap.to(this.headerNbUnlockedHome, {
                        y: 0,
                        ease: 'expo.easeIn',
                        duration: 0.1,
                    })
                },
            })

            gsap.to(nbUnlockedContainer, {
                duration: 0.1,
                ease: 'expo.easeOut',
                y: 40,
                onComplete: () => {
                    nbUnlockedContainer.innerHTML = newNbUnlocked

                    gsap.set(nbUnlockedContainer, {
                        y: -40,
                    })

                    gsap.to(nbUnlockedContainer, {
                        y: 0,
                        ease: 'expo.easeIn',
                        duration: 0.1,
                    })
                },
            })

            // TODO : lottie animation : https://app.clickup.com/t/48qnm3
        }
    }

    achievements_getNbUnlocked() {
        const currentStorage = this.getStorage()
        let nbUnlocked = 0

        if (currentStorage) {
            currentStorage.achievements.forEach((achievement) => {
                if (achievement == 'unlocked') {
                    nbUnlocked++
                }
            })
        }

        return nbUnlocked
    }

    achievements_getListOfUnlocked() {
        const currentStorage = this.getStorage()
        let unlockedAchievementsIndexes = []

        currentStorage.achievements.forEach((achievement, index) => {
            if (achievement == 'unlocked') {
                unlockedAchievementsIndexes.push(index)
            }
        })

        return unlockedAchievementsIndexes
    }

    dispatchNotice(itemIndex, selfClose = true) {
        // Getting the icon
        const itemIcon = this.items[itemIndex]
            .querySelector('.motionTime__item-content .motionTime__item-logo')
            .cloneNode(true)
        const itemTitle = this.items[itemIndex].querySelector(
            '.motionTime__item-content .motionTime__item-title'
        )

        // Creating the notice
        this.notice = document.createElement('div')
        this.notice.classList.add('motionTime__notice')

        // Creating the notice close btn
        const noticeCloseBtn = document.createElement('div')
        noticeCloseBtn.classList.add('notice__closeBtn')
        this.notice.appendChild(noticeCloseBtn)

        noticeCloseBtn.addEventListener('mouseenter', () => {
            document.querySelector('.cursor').classList.add('hovering')
        })

        noticeCloseBtn.addEventListener('mouseleave', () => {
            document.querySelector('.cursor').classList.remove('hovering')
        })

        noticeCloseBtn.addEventListener('click', () => {
            this.notice.classList.add('out')
            setTimeout(() => {
                this.notice.remove()
            }, 500)
        })

        // Creating the unlock view
        let noticeUnlock = document.createElement('div')
        noticeUnlock.classList.add('notice__view-unlock')

        // Unlock animation
        let noticeUnlockAnimation = document.createElement('div')
        noticeUnlockAnimation.classList.add('unlock__animation')
        noticeUnlock.appendChild(noticeUnlockAnimation)

        // Unlock title
        let noticeUnlockTitle = document.createElement('div')
        noticeUnlockTitle.classList.add('unlock__title')
        noticeUnlockTitle.innerHTML = 'Achievement<br>unlocked!'
        noticeUnlock.appendChild(noticeUnlockTitle)

        this.notice.appendChild(noticeUnlock)

        // Creating the achievement view
        let noticeAchievement = document.createElement('div')
        noticeAchievement.classList.add('notice__view-achievement')

        // Achievement icon
        let noticeAchievementIcon = document.createElement('div')
        noticeAchievementIcon.classList.add('achievement__icon')
        noticeAchievement.appendChild(noticeAchievementIcon)
        noticeAchievementIcon.appendChild(itemIcon)

        // Achievement name
        let noticeAchievementName = document.createElement('div')
        noticeAchievementName.classList.add('achievement__name')
        noticeAchievementName.innerText = itemTitle.textContent
        noticeAchievement.appendChild(noticeAchievementName)

        // Achievement "what's this?"
        if (!selfClose) {
            let noticeExplanation = document.createElement('div')
            noticeExplanation.classList.add('achievement__onboard')
            noticeExplanation.innerText = 'What is this?'

            // Declaring the timeline here, and only here. Not needed anywhere else.
            this.initAnimations()
            this.initTriggerEvents()

            noticeExplanation.addEventListener('click', () => {
                this.openMtTimeline.play(0)
                noticeCloseBtn.click()

                setTimeout(() => {
                    document
                        .querySelector('.cursor')
                        .classList.add('color--white')
                }, 250)
            })

            noticeExplanation.addEventListener('mouseenter', () => {
                document.querySelector('.cursor').classList.add('hinting')
                document.querySelector('.cursor').classList.add('color--white')
            })

            noticeExplanation.addEventListener('mouseleave', () => {
                document.querySelector('.cursor').classList.remove('hinting')
                document
                    .querySelector('.cursor')
                    .classList.remove('color--white')
            })

            noticeAchievement.appendChild(noticeExplanation)
        }

        this.notice.appendChild(noticeAchievement)

        if (!selfClose) {
            this.notice.classList.add('first')
        }

        // Loading lottie animation
        const animObj = lottie.loadAnimation({
            path: achievementUnlockedAnimation,
            loop: false,
            autoplay: false,
            renderer: 'svg',
            container: this.notice.querySelector('.unlock__animation'),
        })

        animObj.setSpeed(1.5)

        this.headerCount.classList.add('animating')
        this.headerCountHome.classList.add('animating')

        // When lottie animation finishes..
        animObj.addEventListener('complete', () => {
            // animObj.destroy();
            setTimeout(() => {
                noticeUnlock.classList.add('out')
                noticeAchievement.classList.add('active')

                setTimeout(() => {
                    const achievementOnboard = document.querySelector(
                        '.achievement__onboard'
                    )

                    if (achievementOnboard) {
                        achievementOnboard.classList.add('active')
                    }
                }, 400)

                // Auto close notification after 3s, unless specified otherwise.
                setTimeout(() => {
                    if (selfClose) {
                        noticeCloseBtn.click()
                    }
                    document.body.classList.remove('achievement--unlocking')
                    this.headerCount.classList.remove('animating')
                    this.headerCountHome.classList.remove('animating')
                }, 3000)
            }, 200)
        })

        // Appending notice
        document.body.insertBefore(this.notice, document.body.childNodes[0]) // prepend
        document.body.classList.add('achievement--unlocking')
        setTimeout(() => {
            this.notice.classList.add('active')
            // this.notice.querySelector('.notice__view-unlock').classList.add('active');

            setTimeout(() => {
                animObj.play()
            }, 400)
        }, 200)
    }

    loadVideo(itemIndex) {
        // Composing the video element
        const videoSrcWebm =
            '/wp-content/themes/hellobuckwild/src/videos/motiontime/' +
            (itemIndex + 1) +
            '.webm'
        const videoSrcMp4 =
            '/wp-content/themes/hellobuckwild/src/videos/motiontime/' +
            (itemIndex + 1) +
            '.mp4'
        const videoElement =
            "<video preload='none' muted='true' loop='true'><source type='video/webm' src='" +
            videoSrcWebm +
            "' /> <source type='video/mp4' src='" +
            videoSrcMp4 +
            "' /></video>"

        // Desktop part
        const videoContainer = document.querySelector(
            '.motionTime__item-content-visual .visual__video[data-index="' +
                itemIndex +
                '"]'
        )
        videoContainer.innerHTML = videoElement

        // Responsive part
        const videoContainerResponsive = document.querySelector(
            '.motionTime__responsive__video .video__video[data-index="' +
                itemIndex +
                '"]'
        )
        videoContainerResponsive.innerHTML = videoElement
    }

    unlockItem(itemIndex) {
        const currentStorage = this.getStorage()
        const nbUnlocked = this.achievements_getNbUnlocked()

        if (currentStorage.achievements[itemIndex] !== 'unlocked') {
            this.front_headerUnlock()
            this.front_overlayUnlock(itemIndex)
            this.setStorage(itemIndex)
            this.loadVideo(itemIndex)

            if (document.body.classList.contains('achievement--unlocking')) {
                setTimeout(() => {
                    this.dispatchNotice(itemIndex)
                }, 3000)
            } else {
                if (nbUnlocked >= 1) {
                    this.dispatchNotice(itemIndex)
                } else {
                    // First time unlocking something? Don't self close notice, and init the onboarding procedure.
                    this.initAnimations()
                    this.dispatchNotice(itemIndex, false)
                }
            }
        }
    }
}
